import { useMutation, useQueryClient } from '@tanstack/react-query';

import collectiveApi from 'modules/common/collectiveApi';

const skipSurveyResponse = (surveyId: string) =>
    collectiveApi.post('/surveys/csat/survey/skip/', { survey_id: surveyId }).then((response) => response.data?.ok);

export default function useSkipSurvey() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (surveyId: string) => skipSurveyResponse(surveyId),
        onSuccess: (data) => queryClient.setQueryData(['skipSurvey', data], data),
    });
}
